<div class="m-0 p-0">
    <app-breadcrumb [isStringLiteral]="true" [styleBreadcrumb]="'page-heading'"
        [title]="'FHIR-CHANNELS-INTEGRATED-REFERRAL'" [dob]="patientDOB" [breadcrumb]="patientName" [count]="0"
        [isFhir]="true" [clientRegistrationRequestSent]="clientRegistrationRequestSent" [clientFound]="clientFound" 
        icon="fa-users" (registerClient)="onRegisterClient()">
    </app-breadcrumb>
    <app-flag-list [caseId]="" [memberId]="member.id" *ngIf="member">
    </app-flag-list>
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab title="{{ 'SDOH-REFERRALS' | translate }}" [selected]="true">
            <ng-template kendoTabContent>
                <div class="m-2">
                    <div *ngIf="loaded && !member">
                        {{ (multiplePatientsFound ? 'MORE-THAN-ONE-PATIENT-FOUND' : 
                        clientRegistrationRequestSent ? 'CLIENT-REGISTRATION-REQUEST-SENT' : 'NO-MEMBERS') |
                        translate:patientLabel }}
                    </div>
                    <div *ngIf="loaded && member">
                        <div class="row" *ngIf="fhirService.patientIdContext !== null">
                            <div class="col-sm-12">
                                <button class="k-button k-primary float-right" (click)="backToSummary()">
                                    {{ 'BACK-TO-SUMMARY' | translate }}
                                    <i class="arrow fal fa-angle-right"></i>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="communityEnabled && referralsEnabled">
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr>
                                    <app-case-list-detail [referralsOnly]="true" [patientSummary]="true"
                                        [ehrContext]="true" *ngIf="referralsEnabled && member.id" [caseId]=""
                                        [memberId]="member.id"
                                        (referralsOpenStateChanged)="referralsOpenStateChanged($event)">
                                    </app-case-list-detail>
                                </div>
                            </div>
                            <div class="row w-100 pt-3" *ngIf="!referralsCollapsed">
                                <div class="col-12 p-0 ml-3 mb-2">
                                    <button kendoButton [primary]="false" type="button" (click)="newReferral()"
                                        class="float-right">{{'NEW-REFERRAL' | translate}}<i class="far fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <app-member-assessment *ngIf="ehrShowAssessments && member" [memberId]="member.id" [member]="member" >
                        </app-member-assessment>
                    </div>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab *ngIf="messagesEnabled">
            <ng-template kendoTabTitle>
                {{ 'MESSAGES' | translate }} <span *ngIf="unreadMessages > 0"
                    class="badge badge-pill badge-counts">{{unreadMessages}}</span>
            </ng-template>
            <ng-template kendoTabContent>
                <div class="m-2 pt-3">
                    <input id="inbox" type="radio" kendoRadioButton [(ngModel)]="messageType" name="inbox" value="inbox"
                        [routerLink]="['messages/inbox']" /><label for="inbox" class="pointer"
                        title="{{'INBOX' | translate}}"><i class="fal fa-inbox fa-lg"></i>&nbsp;{{'INBOX' |
                        translate}}</label>
                    <i class="fa-sharp fa-light fa-envelope-circle-check"></i>
                    <input id="sent" type="radio" kendoRadioButton [(ngModel)]="messageType" name="sent" value="sent"
                        class="ml-4" [routerLink]="['messages/sent']" /><label for="sent" class="pointer"
                        title="{{'SENT' | translate}}"><i class="fal fa-paper-plane fa-lg"></i>&nbsp;{{'SENT' |
                        translate}}</label>
                    <input id="deleted" type="radio" kendoRadioButton [(ngModel)]="messageType" name="deleted"
                        value="deleted" class="ml-4" [routerLink]="['messages/deleted']" /><label for="deleted"
                        class="pointer" title="{{'DELETED' | translate}}"><i class="fal fa-trash-alt fa-lg"
                            style="color:inherit"></i>&nbsp;{{'DELETED' | translate}}</label>
                    <hr />
                    <!--Nested reouter outlet for messages-->
                    <router-outlet></router-outlet>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab *ngIf="notesEnabled">
            <ng-template kendoTabTitle>
                {{ 'NOTES' | translate }} <span *ngIf="tabCounts?.notes > 0"
                    class="badge badge-pill badge-counts">{{tabCounts?.notes}}</span>
            </ng-template>
            <ng-template kendoTabContent>
                <div class="m-2">
                    <div *ngIf="!member">
                        {{'NO-NOTES'| translate }}
                    </div>
                    <div class="pt-3" *ngIf="member">
                        <app-notes-list-section [memberId]="member.id" (refresh)="getMemberCountTabs()">
                        </app-notes-list-section>
                    </div>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>

<app-referral [context]="'summary'" *ngIf="member" [memberId]="member.id" #referral></app-referral>